import { FrameSizeSelector, Position } from '~/shared/types';

const sideOffset = '0px';
const centerOffset = '40%';
const stylesMap = {
  mobile: {
    [Position.TopRight]: `top:0;right:0px;`,
    [Position.TopLeft]: `top:0;left:0px;`,
    [Position.CenterLeft]: `top:${centerOffset};left:0px;`,
    [Position.CenterRight]: `top:${centerOffset};right:0px;`,
    [Position.BottomLeft]: `bottom:0px;left:0px;`,
    [Position.BottomRight]: `bottom:0px;right:0px;`,
  },
  desktop: {
    [Position.TopRight]: `top:${sideOffset};right:${sideOffset};`,
    [Position.TopLeft]: `top:${sideOffset};left:${sideOffset};`,
    [Position.CenterLeft]: `top:${centerOffset};left:${sideOffset};`,
    [Position.CenterRight]: `top:${centerOffset};right:${sideOffset};`,
    [Position.BottomRight]: `bottom:${sideOffset};right:${sideOffset};`,
    [Position.BottomLeft]: `bottom:${sideOffset};left:${sideOffset};`,
  },
};

const getIframeStyle = ({
  position,
  size,
}: {
  position: Position;
  size: FrameSizeSelector;
}) => {
  return stylesMap[size][position];
};

export default getIframeStyle;
